import { render } from "./ModalLegales.vue?vue&type=template&id=426dcf9e&scoped=true"
import script from "./ModalLegales.vue?vue&type=script&lang=js"
export * from "./ModalLegales.vue?vue&type=script&lang=js"

import "./ModalLegales.vue?vue&type=style&index=0&id=426dcf9e&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426dcf9e"]])

export default __exports__